<template>
	<div class="w-100 py-4">
		<span id="confirm-page"></span>
		<topNavbar v-if="!is_mobile" page="cart"></topNavbar>
		<div v-if="is_load" class="w-100 my-5 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="p-3 d-block" v-if="error != ''">
        <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
          <div class="row grid-slim-row">
            <div class="col-12 text-center">
              <p class="mb-0 body-3-1">{{error}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
				<div :class="{'chat-container w-100 py-4 px-3':is_mobile,'w-75 mx-auto py-5 my-4': !is_mobile}">
					<div class="row">
						<div class="col-12">
							<p class="heading-6-1 mb-3 pb-2 border-bottom w-100 text-center">Confirm Payment</p>
						</div>
						<div class="col-12" v-if="!is_mobile">
							<div class="w-100 mb-4">
								<div class="box-shadow-main rounded-6 w-100 p-3 bg-light">
									<headerStepOrder :step="3" need_payment></headerStepOrder>
								</div>
							</div>
						</div>
						<div :class="{'col-12': is_mobile,'col-6': !is_mobile}">
							<div class="container p-3 text-left bg-light rounded-6 box-shadow-bold border mb-4">
								<p class="text-center body-1-4 mb-3 pb-3 border-bottom w-100">Bill Detail</p>
								<div class="row">
									<div class="col-6 mb-1">
				            <p class="mb-1 body-2-2 font-regular">{{$t("hotel.success.room-charges")}}</p>
				          </div>
				          <div class="col-6 mb-1">
				            <p class="mb-1 body-2-2 font-regular">: {{formatCurrency(tx.payments.total_payment - tx.payments.total_additional)}}</p>
				          </div>
				          <div class="col-6 mb-1" v-if="tx.payments.total_additional > 0">
				            <p class="mb-1 body-2-2 font-regular">{{$t("hotel.additional-service")}}</p>
				          </div>
				          <div class="col-6 mb-1" v-if="tx.payments.total_additional > 0">
				            <p class="mb-1 body-2-2 font-regular">: {{formatCurrency(tx.payments.total_additional)}}</p>
				          </div>
				          <div class="col-6 mb-1 border-top pt-2">
				            <p class="mb-1 body-2-2 font-bold">{{$t("hotel.total")}}</p>
				          </div>
				          <div class="col-6 mb-1 border-top pt-2">
				            <p class="mb-1 body-2-2 font-bold">: {{formatCurrency(tx.payments.total_payment)}}</p>
				          </div>
				          <div class="col-6 mb-1">
				            <p class="mb-2 body-2-2" :class="{'font-bold': tx.payments.payment_surcharge == 0}">{{ this.$isNotEmptyV2(getMerchant().booking_engine_cart_payable_deposit_label) ? getMerchant().booking_engine_cart_payable_deposit_label : $t('hotel.deposit-due-now')}}</p>
				          </div>
				          <div class="col-6 mb-1">
				            <p class="mb-2 body-2-2" :class="{'font-bold text-green': tx.payments.payment_surcharge == 0}">: {{formatCurrency(tx.payments.total_deposit)}}</p>
				          </div>
				          <template v-if="tx.payments.payment_surcharge > 0">
				          	<div class="col-6 mb-1">
				              <p class="mb-2 body-2-2">{{$t("hotel.payment-surcharge")}}</p>
				            </div>
				            <div class="col-6 mb-1">
				              <p class="mb-2 body-2-2">: {{formatCurrency(tx.payments.payment_surcharge)}}</p>
				            </div>
				            <div class="col-6 mb-1">
				              <p class="mb-2 body-2-2 font-bold">Total {{ this.$isNotEmptyV2(getMerchant().booking_engine_cart_payable_deposit_label) ? getMerchant().booking_engine_cart_payable_deposit_label : $t('hotel.deposit-due-now')}}</p>
				            </div>
				            <div class="col-6 mb-1">
				              <p class="mb-2 body-2-2 font-bold text-green">: {{formatCurrency(Number(tx.payments.total_deposit)+Number(tx.payments.payment_surcharge))}}</p>
				            </div>
				          </template>
				          <template v-if="(tx.payments.total_payment - tx.payments.total_deposit) > 0">
					          <div class="col-6 border-top pt-2">
					            <p class="mb-0 body-2-2 font-bold text-14">{{ this.$isNotEmptyV2(getMerchant().booking_engine_cart_payable_at_hotel_label) ? getMerchant().booking_engine_cart_payable_at_hotel_label : $t('hotel.deposit-due-on-arrival') }}</p>
					          </div>
					          <div class="col-6 border-top pt-2">
					            <p class="mb-0 body-2-2 font-bold text-16 text-orange">: {{formatCurrency(tx.payments.total_payment - tx.payments.total_deposit)}}</p>
					          </div>
				          </template>
								</div>
							</div>
						</div>
						<div :class="{'col-12': is_mobile,'col-6': !is_mobile}">
							<div class="container p-3 text-left bg-light rounded-6 box-shadow-bold border">
								<p class="text-center body-1-4 mb-3 pb-3 border-bottom w-100">Account Detail</p>
								<div class="w-100 mb-3">
				          <p class="mb-1 body-2-2">Bank/E-Wallet Name<span class="text-danger">*</span></p>
				          <input type="text" class="form-control body-2-2 text-14 mb-1" v-model="form.bank_name">
				        </div>
				        <div class="w-100 mb-3">
				          <p class="mb-1 body-2-2">Account Holder<span class="text-danger">*</span></p>
				          <input type="text" class="form-control body-2-2 text-14 mb-1" v-model="form.account_name">
				        </div>
				        <div class="w-100 mb-3">
				          <p class="mb-1 body-2-2">Account Number<span class="text-danger">*</span></p>
				          <input type="text" class="form-control body-2-2 text-14 mb-1" v-model="form.account_number">
				        </div>
				        <div class="w-100 mb-3">
				          <p class="mb-1 body-2-2">Transfer Date<span class="text-danger">*</span></p>
				          <v-date-picker
			              v-model="form.payment_date">
			              <div class="form-control body-2-2 text-14 mb-1 py-2">
			              	{{formatDate(form.payment_date)}}
			              </div>
			            </v-date-picker>
				        </div>
				        <div class="w-100 mb-3">
				        	<p class="mb-1 body-2-2">Transfer Receipt<span class="text-danger">*</span></p>
				        	<div class="text-center mb-4">
				            <label v-if="form.image.original == null" class="w-100 cursor-pointer" for="file_image">
				              <div class="w-100 bg-light-page py-4 border-2-dashed rounded-6 cursor-pointer" style="box-shadow: 4px 3px 4px 0px #ccccccba;">
				                <img src="../../../assets/img/icon/ar-camera-light.png" width="40">
				                <p class="mb-0 pt-1 body-1 text-14 font-bold text-center">{{$t('hotel.action.choose-photo')}}</p>
				                <input type="file" ref="file" accept="image/png, image/jpeg, image/jpg" id="file_image" class="d-none" v-on:change="pushImage" />
				              </div>
				            </label>
				            <div class="w-100 bg-light-page border rounded-6 position-relative" v-else style="box-shadow: 4px 3px 4px 0px #ccccccba;">
				              <div class="rounded-3 bg-back cursor-pointer position-absolute m-2" @click="resetImage" style="z-index: 1049;right: 0">
				                <img src="../../../assets/img/icon/cancel.png" class="p-2" width="30">
				              </div>
				              <img :src="form.image.preview" class="rounded-6 w-100 object-fit" style="height: 190px">
				            </div>
				          </div>
				        </div>
				        <div class="w-100 mb-3" v-if="push_result.message != ''">
				        	<div class="p-3 border mb-3 radius-0 text-center" :class="{
				        		'success-push': !push_result.is_error,
				        		'fail-push': push_result.is_error
				        	}">
			              <p class="mb-0 body-3-1">{{push_result.message}}</p>
			            </div>
				        </div>
				        <div class="row slim-grid-row">
				        	<div class="col-6">
				        		<button type="button" class="button-black w-100 cursor-pointer" @click="goToPaymentResult">Cancel</button>
				        	</div>
				        	<div class="col-6">
				        		<button type="button" class="button-secondary w-100" :disabled="!form_valid" :class="{'button-disabled cursor-disable': !form_valid, 'cursor-pointer': form_valid}" @click="submitData">
				        			<pulse-loader :loading="btn_push" color="#fff" v-if="btn_push"></pulse-loader>
		                  <template v-else>
		                    {{$t("hotel.waiting.confirm-payment")}}
		                  </template>
				        		</button>
				        	</div>
				        </div>
							</div>
						</div>
					</div>
				</div>
      </div>
    </template>
    <!-- FOOTER -->
    <Footer v-if="!is_mobile"></Footer>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex';
	import {post,get} from '@/services/index.js'
	import {formatCurrency,compressImage,formatDate} from '@/utils/index.js'
	import Footer from '@/components/hotel/Footer.vue';
	import CartHeader from '@/components/hotel/be/desktop/cartHeader.vue';
	import topNavbar from '@/components/hotel/be/desktop/navbar.vue';
	import headerStepOrder from '@/components/hotel/be/desktop/headerStepOrder.vue';
	import moment from 'moment'

	export default{
		components:{
			CartHeader,
			topNavbar,
			Footer,
			headerStepOrder
		},
		data(){
			return{
				is_load: true,
				error: '',
				tx:{},
				form:{
					bank_name: '',
					account_name: '',
					account_number: '',
					payment_date: new Date,
					image:{
						original: null,
						preview: null,
						key: 0
					}
				},
				btn_push: false,
				push_result: {
					is_error: false,
					message: ''
				}
			}
		},
		computed:{
			is_mobile(){
				return window.innerWidth > 768 ? false : true
			},
      tx_id(){
				return this.$route.params.tx_order_id
			},
			form_valid(){
				if(this.form.bank_name == '' || this.form.account_name == '' || this.form.account_number == '' || this.form.image.original == null){
					return false
				}else{
					return true
				}
			}
		},
		mounted(){
			document.getElementById('confirm-page').scrollIntoView({
        behavior: 'smooth'
      });
			this.geTxDetail()
		},
		methods:{
			...mapGetters(['getMerchant','getMetaTitleTemplate']),
			formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
      	return formatDate(date);
      },
			geTxDetail(){
				this.is_load = true
				this.error = ''
				let params ={
      		merchant_id : this.getMerchant().id,
				}
        const routeQuery = this.$route.query;
        if(this.$isNotEmptyV2(routeQuery) && this.$isNotEmptyV2(routeQuery.tx_sk)){
          params.tx_sk = routeQuery.tx_sk
        }
				get("CORE_HOTEL","tx-detail/"+this.tx_id,params).then(response=>{
					let res = response.data
					if(res.success){
						let valid_payment_type = res.data.payment_details.bank_name == 'DIRECT_PAYMENT' || res.data.payment_details.bank_name == 'WISE'
						let valid_status = res.data.status == 'WAITING_PAYMENT_CONFIRMATION'
						if(valid_payment_type && valid_status){
							this.tx = res.data
						}else{
							this.goToPaymentResult()
						}
					}else{
						this.error = res.message
					}
					this.is_load = false
				})
			},
			goToPaymentResult(){
				this.$router.push({
					path: `/${this.getMerchant().code}/be/payment-result/${this.tx_id}`,
					query: this.$route.query.tx_sk ? { tx_sk: this.$route.query.tx_sk } : {}
				})
			},
			pushImage(e) {
        e.preventDefault();
        var files = this.$refs.file.files;
        if (!files.length)
          return;
        this.form.image.original = files[0]
        this.form.image.preview = URL.createObjectURL(this.form.image.original);
        this.form.image.key++
      },
      resetImage(){
        this.form.image = {
          preview: null,
          original: null,
          key: 0
        }
      },
      async submitData(){
      	if(this.form_valid){
      		this.btn_push = true
      		this.push_result = {
          	is_error: false,
          	message: ''
          }
      		let img_data = await compressImage(this.form.image.original).then(compressResult=>{
	          if(compressResult != false){
	            return compressResult
	          }else{
	            return null
	          }
	        })

	        let fd = new FormData()

	        fd.append("payment_invoice", img_data, img_data.name)
	        fd.append("merchant_id", this.getMerchant().id)
	        fd.append("bank_name", this.form.bank_name)
	        fd.append("account_name", this.form.account_name)
	        fd.append("account_number", this.form.account_number)
	        fd.append("payment_date", moment(this.form.payment_date).format("YYYY-MM-DD"))

	        post("CORE_HOTEL","tx-detail/"+this.tx_id+"/payment-confirmation",fd).then(response=>{
            let res = response.data
            if(res.success){
            	this.goToPaymentResult()
            }else{
	            this.push_result = {
	            	is_error: !res.success,
	            	message: res.message
	            }
            }
            this.btn_push = false
          })
      	}
      }
		}
	}
</script>
<style scoped>
	.success-push{
		background-color: rgb(243, 255, 249);
		border-color: rgb(184, 254, 205) !important;
	}
	.fail-push{
		background-color: #fbe4d391;
		border-color: #ffd5c8 !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeConfirmPayment.vue